
<script>

import BarList from '../components/bar-list'
import BarGrid from '../components/bar-grid'
import FilterList from '../components/filter-list'
import CrmLeadForm from './crm-lead-form'
import CrmLeadNovoForm from './crm-lead-novo-form'
import CrmFiltrosNegocio from './crm-filtros-negocio'
import { getText, formatDataHoraExtenso } from '../shared/utils'
import { SysVars } from '../main';

export default {
    data () {
        return {
            showFormNovo: false, //exibe a tela de manutencao
            codlead: null,
            filter: '',
            textQuery: '',
            statusQuery: '',
            metadata: this.$store.getters.getEntities.metadata,
            selectedFiltro: null,
            selectedUsuario: null,
            selectedEquipe: null,
        }
    },

    components: {
        BarList, BarGrid, FilterList, CrmLeadNovoForm, CrmLeadForm, CrmFiltrosNegocio
    },

    computed: {
        leadList: function () {
            return this.$store.getters.getLeadCrmList
        },
    },

    watch: {

    },

    filters: {

    },

    methods: {
        formatDate (value) {
            return formatDataHoraExtenso(value, true)
        },
        handleStyle(color) {
            if (color)
              return 'color: white; background-color: ' + color;
            else 
              return ''
        },
        handleStyleAgenda(obj) {
            if (obj.dias_atividade > 0)
              return 'color: red;';
            else 
            if (obj.dias_atividade < 0)
              return 'color: green;'
            else  
              return ''
        },
        handleChangeUsuario (cod) {
            this.selectedUsuario = cod
            this.loadData()
        },
        handleChangeFiltroLeads (cod) {
            this.selectedFiltro = cod
            this.loadData()
        },
        handleChangeEquipe (cod) {
            this.selectedEquipe = cod
            this.loadData()
        },
        handleEdit (codlead) {
            //abre a tela de edicao
            this.codlead = codlead
            this.$modalForm(true)
            // this.$router.push('/crm/pessoa/' + codlead)
        },
        handleAction (act, codlead) {
            if (act == 1) {
                //print
                //apiDownloadPDF(this, 'print/sales/' + codlead)
            } 
        },
        handleNovo () {
            //abre a tela de edicao
            this.codlead = null;
            this.showFormNovo = true; //exibe o form de manutencao
            this.$modalForm(true)
        },
        closeForm() {
            this.showFormNovo = false
            this.codlead = null;
            this.$modalForm(false)
            // this.$scrollTo(0)
            this.loadData()
        },
        textSearch(value) {
            //efetua a pesquisa por texto
            this.textQuery = 'text=' + value
            this.loadData()
        },
        handleFilterList (status) {
            if (status === 'todos') {
                this.statusQuery = ''
            } else {
                this.statusQuery = 'filtro=' + status
            }
            this.loadData()
        },
        textAtividade (count) {
            if (count == 1)
                return '1 Atividade Atrasada'
            else if (count > 1)
                return count + ' Atividades Atrasadas'
            else
                return ''
        },
        loadData() {
            let query = ''
            if (!this.selectedFiltro || this.selectedFiltro === 0) {
                query = ''
            } else {
                query = 'filtro=' + this.selectedFiltro
            }

            if (this.selectedUsuario) {
              if (query)
                query = query + '&'
              query = query + 'codusuario=' + this.selectedUsuario
            }

            if (this.selectedEquipe) {
              if (query)
                query = query + '&'
              query = query + 'codequipe=' + this.selectedEquipe
            }

            let param = {}
            param.query = ''
            if (query) {
                param.query = query
                if (this.textQuery) {
                     param.query = param.query + '&'
                }
            }
            if (this.textQuery) {
                param.query = param.query + this.textQuery
            } else {
                param.filter = this.filter
            }
            this.$store.dispatch('loadLead', param)
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },
    },

    created () {
        this.$store.dispatch('loadConfigCrm', this).then(
            this.loadData()
        )

        // let filters = [
        //     { label: 'Todos os Contatos', qt: null, status: null },
        //     { label: 'Contatos com negócio em aberto', qt: null, status: 'comnegocio' },
        //     { label: 'Contatos com atividade pendente', qt: null, status: 'comagenda' },
        // ]
        // this.paramFilterList = { total: filters, selectedStatus: '' }
        
    }

}

</script>

<template>
    <div>
        <div id="list"> 

            <bar-list
                :refresh-button="true" 
                :new-button="true" 
                :pdf-button="false"
                :xls-button="true"
                single-entity="Lead" 
                plural-entity="Leads"
                @search="textSearch"
                @new="handleNovo"
                @refresh="loadData">
            </bar-list>

            <div class="mt-2">
                <crm-filtros-negocio :leads="true" @changeUsuario="handleChangeUsuario" @changeEquipe="handleChangeEquipe" @changeFiltroLeads="handleChangeFiltroLeads"></crm-filtros-negocio>
            </div>  

            <div class="default-container">
                <div v-if="leadList.length == 0" class="no-content mb-4">Nenhum lead foi encontrado</div>
                <div class="mainbox" v-for="(lead, index) in leadList" :key="index">
                    <div class="row p-2">
                        <div class="col-auto text-center">
                            <div class="list-icon">
                                <i class="fa fa-exclamation" aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class="col-md-6 col-12">
                            <span class="list-title">{{ lead.titulo }}</span>
                            <span v-if="lead.excluido=='S'" class="badge badge-red ml-2">Excluído</span>
                            <span v-if="lead.stlead=='F'" class="badge badge-yellow ml-2">Arquivado</span>
                            <div class="w-100"></div>
                            <span class="lbl-list-detalhe"><i class="fa fa-calendar pr-2" aria-hidden="true"></i> {{ lead.data | formatDataHoraExtenso }}</span>
                            <span class="lbl-list-detalhe"><i class="fa fa-user-circle pr-2" aria-hidden="true"></i> {{ lead.nome_usuario }}</span>
                            <div class="w-100"></div>
                            <div v-if="lead.fonenumero">
                                <span class="lbl-list pr-2"><i class="fa fa-phone pr-2" aria-hidden="true"></i> {{ lead.fonenumero | formatFone }}</span>
                            </div>
                            <div class="w-100"></div>
                            <!-- <span v-if="lead.organizacao.length>0" class="lbl-list w-100" :href="'#/crm/organizacao/'+lead.codorg"><i class="fa fa-university pr-2" aria-hidden="true"></i> {{ lead.organizacao[0].nome }}</span> -->
                        </div>
                        <div class="col-md-2 col-4">
                            <span v-if="lead.tag.length>0" class="tag-input-color mr-3" :style="handleStyle(lead.tag[0].cor)" @click="handleEditarlead('nome')"> {{ lead.tag[0].descricao }} </span>
                        </div>
                        <div class="col-md-2 col-4">
                            <span class="icon icon-atrasado" v-if="lead.dias_atividade>0" :title="'Atividade atrasada há ' + lead.dias_atividade + ' dias'" data-toggle="tooltip" data-placement="top"><i class="fa fa-calendar" aria-hidden="true"></i></span>
                            <span class="icon icon-sem-agenda" v-if="lead.count_agenda == 0" data-toggle="tooltip" data-placement="top" title="Nenhuma atividade"><i class="fa fa-warning" aria-hidden="true"></i></span>
                            <span class="icon icon-agenda" v-if="lead.count_agenda > 0 && lead.dias_atividade <= 0" data-toggle="tooltip" data-placement="top" title="Atividade planejada"><i class="fa fa-calendar" aria-hidden="true"></i></span>
                            <label class="lbl-list icon-sem-agenda" v-if="!lead.proxima_atividade">Sem Atividade</label>
                            <span class="data-list" :style="handleStyleAgenda(lead)"> {{ formatDate(lead.proxima_atividade) }} </span>
                        </div>
                        <div class="col-auto ml-auto">
                            <bar-grid 
                                :options="{barDefault: true, btnEdit: true}"
                                :moreActions="[]"
                                @edit="handleEdit(lead.codlead)"
                                @action="handleAction(id, lead.codlead)">
                            </bar-grid>
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <crm-lead-novo-form v-if="showFormNovo" :index="codlead" @closeform="closeForm"></crm-lead-novo-form>

        <div class="deal-form-side" v-if="codlead">
            <crm-lead-form :index="codlead" @closeform="closeForm"></crm-lead-form>
        </div>
    </div>
</template>


<style>

.list-title {
    display: inline-block;
    max-width: 100%;
    /* font-size: 16px; */
    font-weight: 700;
    color: #4993d2;
}

.list-icon {
    font-size: 24px; 
    align-items: center; 
    justify-content: center; 
    background-color: #f5f5f5; 
    border: solid 1px #E0E0E0; 
    box-sizing: border-box; 
    height: 38px; 
    width: 42px; 
    flex-shrink: 0;
}

</style>



// WEBPACK FOOTER //
// src/forms-crm/crm-lead-list.vue